module.exports = flarum.core.compat['common/ForumApplication'];